import { GlobalAppState } from '@model/state';
import { createSelector } from '@reduxjs/toolkit';

// Base selector
const selectCommonSearchState = (state: GlobalAppState) => state.search.common;

// Memoized selectors
export const getTabIndex = createSelector([selectCommonSearchState], (commonSearch) => commonSearch.tabIndex);

// Additional selectors
export const getCurrentTab = createSelector([selectCommonSearchState], (commonSearch) => commonSearch.tabIndex);
